{
  "legalConfirmLabel": "닫기",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "개인정보 처리방침",
  "legalTermsOfUse": "사용 약관",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms_kr",
  "profileLegalNoticesMenuItem": "법적 고지 사항"
}
